export const isEmpty = (obj: unknown): boolean => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <boolean>obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
  );
};
